import { Badge } from '@heidi/design-system/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@heidi/design-system/tooltip';
import { Info } from 'lucide-react';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { recommendedSeatBadgeMessages as messages } from './recommended-seat-badge.messages';

/** "Recommended" on the Max seat, with a tooltip saying it comes from this month's usage. */
export function RecommendedSeatBadge() {
  const intl = useIntl();
  const tooltip = intl.formatMessage(messages.recommendedTooltip);
  // A tap must open it on touch screens, which never hover. It opens rather than
  // toggles because the tap's focus may already have opened it. Preventing
  // default stops Radix's own click handler closing it; a tap outside closes it.
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Badge size="xs" color="green">
      {intl.formatMessage(messages.recommended)}
      <Tooltip open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger
          className="inline-flex"
          aria-label={tooltip}
          onClick={(event) => {
            event.preventDefault();
            setIsOpen(true);
          }}
        >
          <Info className="size-3" aria-hidden />
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </Badge>
  );
}
